import { Grid, IconButton, TextField } from '@mui/material'
import Visibility from '@mui/icons-material/Visibility'
import VisibilityOff from '@mui/icons-material/VisibilityOff'
const Input = ({half, name, label, autoFocus, type, onChange, handleShowPwd}) => {
    return ( 
        <Grid item sm={ half ? 6 : 12 }>
            <TextField variant='outlined' required fullWidth name={name} label={label} onChange={onChange} autoFocus={autoFocus} type={type} xs={12}
            InputProps = { name === 'password' ? { endAdornment: (
                <IconButton onClick={handleShowPwd} >
                    { type === 'password' ? <Visibility /> : <VisibilityOff /> }
                </IconButton>
            )} : null }
            />
        </Grid>
     );
}
 
export default Input;